
import Vue from 'vue'
import { Amplify, Auth } from 'aws-amplify';
import '@aws-amplify/ui-vue';
import aws_exports from './aws-exports';
import awsauth from './awsauth';

// Font-awesome
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

// Bootstrap
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)

import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = process.env.NODE_ENV === 'production'
Amplify.configure(aws_exports);

// Federated auth
Auth.configure({
  oauth: awsauth
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
